import { useState } from "react";

//style
import "./IconButtonWithTooltip.scoped.scss";

//common components
import Tooltip from "../tooltip/Tooltip";

const IconButtonWithTooltip = ({ text, icon, background = "blue", disabled, border, onClick = () => {} }) => {
	const [hovering, setHovering] = useState(false);
	if (disabled) onClick = () => {};

	return (
		<button
			className={`icon_button_with_tooltip ${background} ${disabled && "disabled"} ${!disabled && border && "border"}`}
			onClick={onClick}
			onMouseOver={() => setHovering(true)}
			onMouseOut={() => setHovering(false)}
		>
			<Tooltip text={text} position="bottom" compact={true} icon={icon} customHover={hovering} />
		</button>
	);
};

export default IconButtonWithTooltip;
